<div class="modal-bg project-dialog-backdrop">
    <div class="form modal-dialog-container project-dialog-container">
        <div class="dialog-header project-dialog-header">
            <div class="header-copy">
                <span class="dialog-eyebrow">Workspace / {{ project ? 'Edit project' : 'New project' }}</span>
                <h2>{{ dialogTitle }}</h2>
            </div>
            <button type="button" class="dialog-close-btn" (click)="cancel()" aria-label="Close">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </div>

        <form class="project-dialog-form" [formGroup]="form" #f="ngForm">
            <div class="project-dialog-body">

                <fieldset id="tutorial-project-name-fieldset" class="fieldset project-name-fieldset">
                    <label for="projectName">Project name</label>
                    <input id="projectName" class="project-name-input" placeholder="Project name" formControlName="projectName">
                    <span class="field-hint" *ngIf="project">Project names can't be changed once the project has been created.</span>

                    <div *ngIf="projectName.pristine == false && projectName.status == 'INVALID'" >
                        <div class="form-error-msg" *ngIf="projectName.errors?.isFormNameTaken">
                            That name is already taken
                        </div>
                        <div class="form-error-msg" *ngIf="projectName.errors?.required">
                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                            Project name is required
                        </div>
                        <div class="form-error-msg" *ngIf="projectName.errors?.minlength">
                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                            Project name should be at least {{ projectName.errors.minlength.requiredLength }} characters long
                        </div>
                        <div class="form-error-msg" *ngIf="projectName.errors?.maxlength">
                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                            Project name should be at most {{ projectName.errors.maxlength.requiredLength }} characters long
                        </div>
                        <div class="form-error-msg" *ngIf="projectName.errors?.pattern">
                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                            Please avoid special characters in the name
                        </div>
                    </div>

                </fieldset>


                <!--
                <app-documentation-form *ngIf="standardDirectoryStructure.value" [context]="this"></app-documentation-form>
                <app-sessions-form [project]="this.project" [parentForm]="this" [formContextId]="this.formContextId" [projectManager]="this.projectManager"></app-sessions-form>
                -->


                <app-sessions-form class="tutorial-sessions-form" #sessionsForm [project]="this.project" [parentForm]="this" [formContextId]="this.formContextId" [projectManager]="this.projectManager"></app-sessions-form>

                <section class="project-setup">
                    <div class="setup-heading">
                        <div class="setup-heading-copy">
                            <h3>Project setup</h3>
                            <p>Settings for the whole project, usually made once when it's created</p>
                        </div>
                    </div>

                    <div class="setup-list">
                        <details class="setup-row project-info-details">
                            <summary class="setup-row-summary">
                                <i class="fa fa-chevron-right details-chevron" aria-hidden="true"></i>
                                <span class="setup-row-icon" aria-hidden="true"><i class="fa fa-info-circle"></i></span>
                                <span class="setup-row-copy">
                                    <span class="setup-row-title">About this project</span>
                                    <span class="setup-row-subtitle">Description, funding, language, ethics review and quality control</span>
                                </span>
                            </summary>
                            <div class="project-info-content">
                                <div class="info-field">
                                    <label for="projectDescription">Description</label>
                                    <textarea id="projectDescription" class="project-info-input project-info-textarea" formControlName="description" placeholder="Describe the project"></textarea>
                                </div>
                                <div class="info-field">
                                    <label for="projectFinancers">Financers</label>
                                    <input id="projectFinancers" type="text" class="project-info-input" formControlName="financers" placeholder="Financers">
                                </div>
                                <div class="info-field">
                                    <label for="spokenLanguage">Spoken language</label>
                                    <input id="spokenLanguage" type="text" class="project-info-input" formControlName="spokenLanguage" placeholder="Free text, e.g. Swedish">
                                </div>
                                <div class="info-field">
                                    <label for="recordingDevice">Recording device</label>
                                    <input id="recordingDevice" type="text" class="project-info-input" formControlName="recordingDevice" placeholder="Free text, e.g. Zoom H5">
                                </div>
                                <div class="info-field">
                                    <label for="ethicsReviewDnr">Dnr from the Swedish Ethical Review Authority</label>
                                    <input id="ethicsReviewDnr" type="text" class="project-info-input" formControlName="ethicsReviewDnr" placeholder="Ethical review Dnr">
                                </div>
                                <div class="info-field">
                                    <label for="qualityControlMethods">Methods of quality control</label>
                                    <select id="qualityControlMethods" class="project-info-input project-info-multiselect" multiple formControlName="qualityControlMethods">
                                        <option *ngFor="let option of qualityControlMethodOptions" [value]="option.id">{{ option.label }}</option>
                                    </select>
                                    <span class="info-field-hint">Hold Ctrl / Cmd to select multiple options</span>
                                </div>
                            </div>
                        </details>
                        <ng-container *ngTemplateOutlet="sessionsForm.annotationStructureTemplate"></ng-container>
                        <app-documentation-form #documentationForm *ngIf="standardDirectoryStructure.value" [context]="this"></app-documentation-form>
                    </div>
                </section>
            </div>

            <div class="dialog-actions">
                <span class="save-status" [ngClass]="{'save-status-dirty': hasUnsavedChanges && !isLoading}">
                    <ng-container *ngIf="isLoading">
                        <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> Working…
                    </ng-container>
                    <ng-container *ngIf="!isLoading && !fileUploadsComlete">
                        <i class="fa fa-cloud-upload" aria-hidden="true"></i> Uploading files…
                    </ng-container>
                    <ng-container *ngIf="!isLoading && fileUploadsComlete && hasUnsavedChanges">
                        <span class="status-dot" aria-hidden="true"></span> Unsaved changes
                    </ng-container>
                    <ng-container *ngIf="!isLoading && fileUploadsComlete && !hasUnsavedChanges">
                        {{ project ? 'No unsaved changes' : 'Not created yet' }}
                    </ng-container>
                </span>
                <button type="button" class="cancel-btn" (click)="cancel()" [disabled]="isLoading">Cancel</button>
                <button id="submitBtn" type="button" [ngClass]="{'disabled': !submitBtnEnabled}" [disabled]="!submitBtnEnabled" (click)="saveProject(f)">
                    <img *ngIf="showLoadingIndicator" src="../../../../assets/loading-indicator-4-light.svg" alt="">
                    <i *ngIf="!showLoadingIndicator" class="fa fa-save" aria-hidden="true"></i>
                    {{ submitBtnLabel }}
                </button>
            </div>

        </form>
    </div>
</div>
